// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"a5d13650","619":"fe6c587f","667":"f27bf12b","831":"d4dc003a","920":"b65bb0bb"}[chunkId] + ".chunk.css";
};